import { render, staticRenderFns } from "./ImpRemember.vue?vue&type=template&id=523f63d2&scoped=true&"
import script from "./ImpRemember.vue?vue&type=script&lang=js&"
export * from "./ImpRemember.vue?vue&type=script&lang=js&"
import style0 from "./ImpRemember.vue?vue&type=style&index=0&id=523f63d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523f63d2",
  null
  
)

export default component.exports